// Pac-Man munching a row of $ signs; shown while What's it worth is valuing items.
export default function PacManLoader({ size = 16, label, testid = "pacman-loader" }) {
  const dots = 5;
  return (
    <span className="pm-wrap inline-flex items-center gap-2" style={{ "--pm": `${size}px` }} role="status" data-testid={testid}>
      <span className="pm-track" aria-hidden="true">
        <span className="pm-dollars">
          {Array.from({ length: dots * 2 }, (_, i) => <span key={i} className="pm-dollar">$</span>)}
        </span>
        <span className="pm-man"><span className="pm-jaw pm-top" /><span className="pm-jaw pm-bottom" /></span>
      </span>
      {label && <span className="text-[11px] text-[#0053DA]">{label}</span>}
    </span>
  );
}
